import {Route, useHistory} from 'react-router-dom';
import { useAuth } from '../hooks/auth/useAuth';
import { AuthXService } from '@brg/auth';
import styled from 'styled-components';

const PrivateRouteWrapper = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100000;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    background-color: ${(p) => p.theme.navigationBar.backgroundColor};
    color: ${(p) => p.theme.navigationBar.textActiveColor};
`;

export const PrivateRoute = ({ component: RenderComponent, ...rest }: any) => {
    const { emit } = useAuth();
    const history = useHistory();
    const isAuthenticated = AuthXService.isAuthenticated();

    if (!isAuthenticated) {
        emit('login_replace');
    }

    if (isAuthenticated) {
        return (
            <Route
                {...rest}
                render={(props: any) => (<RenderComponent {...props} />)}
            />
        );
    }

    return (
      <PrivateRouteWrapper>
        Redirecting to&nbsp;
        <a href="/" onClick={(e) => {
          e.preventDefault();
          emit('login');
        }}>
          login
        </a>
        ...
      </PrivateRouteWrapper>
    );
};
import {Route, useHistory} from 'react-router-dom';
import { useAuth } from '../hooks/auth/useAuth';
import { AuthXService } from '@brg/auth';
import styled from 'styled-components';

const PrivateRouteWrapper = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100000;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    background-color: ${(p) => p.theme.navigationBar.backgroundColor};
    color: ${(p) => p.theme.navigationBar.textActiveColor};
`;

export const PrivateRoute = ({ component: RenderComponent, ...rest }: any) => {
    const { emit } = useAuth();
    const history = useHistory();
    const isAuthenticated = AuthXService.isAuthenticated();

    if (!isAuthenticated) {
        emit('login_replace');
    }

    if (isAuthenticated) {
        return (
            <Route
                {...rest}
                render={(props: any) => (<RenderComponent {...props} />)}
            />
        );
    }

    return (
      <PrivateRouteWrapper>
        Redirecting to&nbsp;
        <a href="/" onClick={(e) => {
          e.preventDefault();
          emit('login');
        }}>
          login
        </a>
        ...
      </PrivateRouteWrapper>
    );
};
